import endpoints from '@app/src/api/endpoints'
import { FetchKey } from '@app/src/api/fetchHooks'
import { useCreateResourceWithoutBody } from '@app/src/api/updateHooks'
import type RequestError from '@app/src/errors/RequestError'
import useErrorNotification from '@app/src/hooks/errorNotification'
import { useQueryClient } from '@tanstack/react-query'

export function useGenerateMyProfile() {
  const { showErrorNotification } = useErrorNotification()
  const { mutateAsync, isPending } = useCreateResourceWithoutBody()
  const queryClient = useQueryClient()

  const generateMyProfile = async (): Promise<boolean> => {
    try {
      await mutateAsync({ url: endpoints.generateMyProfile })
      queryClient.invalidateQueries({ queryKey: [FetchKey.Provider, 'my-profile'] })
      return true
    } catch (error) {
      showErrorNotification({ requestError: error as RequestError, disableAutoClose: true })
      return false
    }
  }

  return { generateMyProfile, isGenerating: isPending }
}
